import React from 'react';
import { useInView } from '../hooks/useInView';

/**
 * Reveal wraps content with scroll-triggered fade/slide animations.
 * Variants: fade-up (default), fade, scale, stagger
 * Use `delay` (ms) to offset, `as` to change wrapper element.
 */
export const Reveal = ({ children, variant = 'fade-up', delay = 0, as: Tag = 'div', className = '', stagger = false, ...rest }) => {
  const [ref, inView] = useInView();
  const classes = [
    'reveal',
    `reveal-${variant}`,
    inView ? 'is-visible' : '',
    stagger ? 'reveal-stagger' : '',
    className
  ].filter(Boolean).join(' ');

  const style = delay ? { transitionDelay: `${delay}ms`, ...rest.style } : rest.style;

  return (
    <Tag ref={ref} className={classes} {...rest} style={style}>
      {children}
    </Tag>
  );
};
